export * from './lib/support-feature.module';
export * from './lib/directives/about-popup-trigger/about-popup-trigger.directive';
export * from './lib/directives/support-link/support-link.directive';
